var exports = {
  "WR": "x234b8571--d9929a--apartments",
  "lD": "x234b8571--d9929a--apartments__item",
  "KH": "x234b8571--d9929a--apartments__line",
};

module.exports = exports;
